/**
 * Created by ICG-DL-035 on 2017/12/18.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import funcitonModule from "@/store/modules/function.js"; //引入模块
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    funciton: funcitonModule,
  },
  state:{
    //起始时间
    startTime:'',
    //体系配置首页数据
    systemArr:'',
    //配置积分页
    jiFenArr:'',
    //配置星级页
    xingJiArr:'',
    //星级设定
    xingJiEdit:'',
    //星级排序
    sortStar:[],
    //配置信用页
    xinYongArr:[],
    //信用排序
    sortPro:[],
    //保存工作广场首页数据
    workSquareInfo:null,
    //判断工作广场是否可修改
    workSquareIsEdit:null,
    //判断用户登陆是否超时
    loginTimeOut:false,
    //岗位发布页是否有数据
    postJobHasData:false,
    //任务发布页是否有数据
    postTaskHasData:false,
  },
  mutations:{
    changeStartTime(state,startTime){
      state.startTime = startTime
    },
    changeSystemArr(state,arr){
      state.systemArr = arr
    },
    changejiFenArr(state,arr){
      state.jiFenArr = arr
    },
    changeXingJiArr(state,arr){
      state.xingJiArr = arr
    },
    changeXingJiEditArr(state,arr){
      state.xingJiEdit = arr
    },
    changeSortStar(state,arr){
      state.sortStar = arr
    },
    changeXinYongArr(state,arr){
      state.xinYongArr = arr
    },
    changeSortPro(state,arr){
      state.sortPro = arr
    },
    saveWorkSquareInfo(state,arr){
      state.workSquareInfo = arr
    },
    workSquareIsEditMethods(state,arr){
      state.workSquareIsEdit = arr
    },
    changeLoginTimeOutTo(state,boolean){
      state.loginTimeOut = boolean
    },
    changePostJobHasDataTo(state,boolean){
      state.postJobHasData = boolean
    },
    changePostTaskHasDataTo(state,boolean){
      state.postTaskHasData = boolean
    },
  },
  getters:{
    systemArr:state => state.systemArr,
  },
  actions:{

  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js